import React, { useEffect, useState } from 'react';
import { authAPI } from '@/services/authAPI';

/**
 * WhatsAppFloatButton — small floating "Chat on WhatsApp" pill for candidates who
 * are surfing the web app. Uses the backend's WhatsApp info endpoint (falls back
 * to REACT_APP_WHATSAPP_NUMBER). Anchored bottom-left so it doesn't collide with
 * the Jay floating bot on bottom-right.
 */
export default function WhatsAppFloatButton() {
  const [waLink, setWaLink] = useState(null);

  useEffect(() => {
    let alive = true;
    (async () => {
      try {
        const info = await authAPI.getWhatsAppInfo();
        if (!alive) return;
        if (info?.enabled && info.wa_link) { setWaLink(info.wa_link); return; }
      } catch (_) { /* fall through to env fallback */ }
      const fallback = process.env.REACT_APP_WHATSAPP_NUMBER;
      if (fallback) setWaLink(`https://wa.me/${fallback}?text=Hi%20Numuv`);
    })();
    return () => { alive = false; };
  }, []);

  if (!waLink) return null;

  return (
    <a
      href={waLink}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat with Numuv on WhatsApp"
      data-testid="wa-float-button"
      className="fixed bottom-6 left-6 z-40 flex items-center gap-2 pl-3 pr-4 py-2.5 rounded-full bg-[#25D366] hover:bg-[#1ebe57] text-white shadow-lg shadow-emerald-900/20 transition-transform hover:scale-[1.03] active:scale-95"
    >
      <svg width="22" height="22" viewBox="0 0 32 32" fill="currentColor" aria-hidden="true">
        <path d="M16.001 3.2c-7.05 0-12.8 5.75-12.8 12.8 0 2.257.596 4.475 1.732 6.42L3.2 28.8l6.545-1.703a12.72 12.72 0 0 0 6.256 1.63h.005c7.05 0 12.795-5.746 12.795-12.797 0-3.418-1.333-6.63-3.75-9.05a12.72 12.72 0 0 0-9.05-3.68zm0 23.35h-.004a10.6 10.6 0 0 1-5.4-1.48l-.386-.23-3.882 1.01 1.035-3.78-.25-.4a10.6 10.6 0 0 1-1.625-5.667c0-5.87 4.783-10.65 10.66-10.65 2.847 0 5.522 1.108 7.536 3.122a10.6 10.6 0 0 1 3.12 7.535c-.002 5.87-4.786 10.65-10.65 10.65zm5.83-7.98c-.32-.16-1.892-.933-2.185-1.04-.293-.107-.507-.16-.72.16-.213.32-.826 1.04-1.013 1.253-.187.213-.373.24-.693.08-.32-.16-1.35-.498-2.573-1.588-.95-.848-1.593-1.895-1.78-2.215-.187-.32-.02-.493.14-.653.144-.144.32-.373.48-.56.16-.187.213-.32.32-.533.107-.213.053-.4-.027-.56-.08-.16-.72-1.735-.986-2.375-.26-.625-.525-.54-.72-.55-.187-.008-.4-.01-.613-.01-.213 0-.56.08-.853.4-.293.32-1.12 1.093-1.12 2.666 0 1.573 1.147 3.093 1.307 3.307.16.213 2.253 3.44 5.46 4.827.763.33 1.36.527 1.826.674.767.244 1.464.21 2.014.128.615-.092 1.893-.774 2.16-1.52.267-.747.267-1.388.187-1.52-.08-.133-.293-.213-.613-.373z"/>
      </svg>
      <span className="text-sm font-medium hidden sm:inline">Chat on WhatsApp</span>
    </a>
  );
}
